export default {
  data() {
    return {
      validationServeur: true,
    };
  },
  methods: {
    serveurRule(field) {
      return () => {
        if (this.validationServeur && this.errors) {
          const error = this.errors.fields[field];
          if (error) {
            return error.map(e => e.defaultMessage).join(', ');
          }
        }
        return true;
      };
    },
    nestedServeurRule(field) {
      return () => {
        if (!this.errors) {
          return true;
        }

        const error = Object.entries(this.errors.fields).flatMap(e => {
          const key = e[0];
          const value = e[1];

          if (key.startsWith(field)) {
            return [value];
          }
          return [];
        });
        if (error && error.length) {
          return error.map(e => e.defaultMessage).join(', ');
        }
        return true;
      };
    },
  },
};
